import React, { useRef, useEffect } from 'react';
import { NoContentMessage } from '../../../editor-ui/baseComponents';
import { Heading, Icon, EditorContainer, fieldType } from './helpers';

export default function VideoField({ field }) {
  const fieldRef = useRef(null);
  const containerId = `js-video-field-${field.id}`;

  useEffect(() => {
    if (window.page && fieldRef.current && field.assetPresent){
      window.storyViews = window.storyViews || [];
      window.storyViews.push(
        window.page.init(
          "VideoFieldView",
          {
            el: document.getElementById(containerId),
            inputId: `#multipart-asset-uploader-Field-${field.id}`,
            fieldId: field.id,
            bucket: field.assetBucketName,
            asset: {
              asset_id: field.assetId,
              persisted: true,
              assetableType: "Field",
              assetableId: field.id,
              url: field.assetUrl,
              title: field.assetName
            }
          }
        )
      );
    }
  }, [containerId, fieldRef, field.id, field.assetPresent, field.assetId, field.assetUrl,
      field.assetName, field.assetBucketName]);

  return (
    <React.Fragment>
      <Heading>
        <Icon type="video" />
        { field.name }
      </Heading>
      <EditorContainer
        id={containerId}
        ref={fieldRef}
        className="custom-field-container"
      >
        {!field.assetPresent && <NoContentMessage contentType="video" />}
      </EditorContainer>
    </React.Fragment>
  );
}

VideoField.propTypes = {
  field: fieldType.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/customFields/VideoField.jsx